<template>
    <vue-final-modal
        v-bind="$attrs"
        v-slot="{ close }"
    >
        <div class="opui-modal">
            <div class="opui-modal-dialog">
                <div class="opui-modal-content">
                    <div class="opui-modal-header">
                        <h1>
                            {{ $e('Create New Page') }}
                        </h1>
                        <i @click.prevent="close" class="opui-icon-close opui-modal-close"></i>
                    </div>

                    <div class="opui-modal-body">
                        <form class="opui-form" @submit.prevent="save">
                            <div class="opui-row">
                                <div class="opui-col-md-8">
                                    <div class="opui-form-group">
                                        <label>{{ $e('Page Title') }}</label>
                                        <input type="text" class="opui-form-control" placeholder="Enter page title" autofocus required v-model="title">
                                    </div>
                                </div>

                                <div class="opui-col-md-4">
                                    <div class="opui-form-group">
                                        <label>{{ $e('Post Type') }}</label>
                                        <select class="opui-form-control" v-model="postType" style="line-height: 140%;" required>
                                            <option :value="postType.id" v-for="postType in window.OptimizeTemplates.enabled_post_types">{{ postType.title }}</option>

                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="opui-form-actions opui-justify-content-between opui-flex opui-pt-5">
                                <button type="button" class="opui-btn opui-btn-outline-secondary opui-px-6" @click.prevent="closeAllModals">{{ $e('Cancel') }}</button>

                                <button type="submit" class="opui-btn opui-btn-primary" :class="{ saving: saving, disabled: saving }" :disabled="saving">
                                    <span class="opui-spinner opui-spinner-border opui-text-light opui-mr-2"></span>
                                    <span class="opui-btn-saving-label">{{ $e('Creating new page...') }}</span>
                                    <span class="opui-btn-label">{{ $e('Create Page') }}</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </vue-final-modal>
</template>

<script>
export default {
    data() {
        return {
            title:    '',
            postType: 'page',
            saving:   false,
        }
    },
    props: {
        template: { type: Object, required: true },
    },
    methods: {
       /**
         * Save new course and close modal
         */
        save() {
            this.saving = true

            this.$http
                .post('/templates/create-page', {
                    title:         this.title,
                    template_uid:  this.template.uid,
                    post_type:     this.postType,
                    type:          this.template.type,
                })
                .then(response => {
                    if (response.status === 200 && response.data.data.editUrl) {
                        window.location.replace(response.data.data.editUrl)
                        // this.closeAllModals()
                        // this.$toast.success('Page saved.')
                        // this.openEditor(response.data.data.pageId)
                        // this.saving = false
                    } else {
                        this.closeAllModals()
                        this.$toast.error(`Error when saving`)
                        this.saving = false
                    }
                }).catch(error => {
                    this.$toast.error(`Error when saving`)
                    this.saving = false
                })
        },
    },
}
</script>
